export default "__VITE_ASSET__ecGLOJ_V__"